import styles from "./AccountCards.module.scss";
import {useEffect, useState} from "react";
import emptyCardIcon from "../../../assets/images/icons/empty-card.svg";
import addIcon from "../../../assets/images/icons/add.svg";
import {useTranslation} from "react-i18next";
import AccountCardItem from "./AccountCardsItem/AccountCardsItem";
import useAppSelector from "../../../hooks/useAppSelector";
import Spinner from "../../../components/Spiner/Spinner";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {PaymentMethodService} from "../../../services/paymentMethodService";
import {IPaymentMethod} from "../../../models/IPaymentMethod";
import StripeElements from "../../../components/StripeElements/StripeElements";
import AddPaymentMethodPopup from "../../../components/AddPaymentMethodPopup/AddPaymentMethodPopup";

const AccountCards = () => {

    const {t} = useTranslation();
    const {profile} = useAppSelector(state => state.profileSlice);

    const [paymentMethods, setPaymentMethods] = useState<{ loader: boolean, data: IPaymentMethod[] }>({
        loader: true,
        data: []
    });
    const [showAddPaymentPopup, setShowAddPaymentPopup] = useState<boolean>(false)

    useEffect(() => {
        if (profile) {
            getPaymentMethods(profile.customerId);
        }
    }, [profile])

    const getPaymentMethods = async (customerId: number) => {
        setPaymentMethods({loader: true, data: []});
        try {
            const response = await PaymentMethodService.getPaymentMethodsByCustomerId(customerId);
            setPaymentMethods({loader: false, data: response.data});
        } catch (e) {
            setPaymentMethods({loader: false, data: []});
        }
    }

    const hideAddPaymentMethodPopup = () => {
        setShowAddPaymentPopup(false);
    }

    if (paymentMethods.loader) {
        return (
            <div className="loader-wrapper">
                <Spinner/>
            </div>
        )
    }

    if (!paymentMethods.data.length) {
        return (
            <>
                <section className={styles.section}>
                    <div className={styles.emptyWrapper}>
                        <img className={styles.icon} src={emptyCardIcon} alt={"empty"}/>
                        <h2 className={styles.text}>{t("YouHaveNoCardsAvailable")}</h2>
                        <CustomButton
                            text={t("AddNewCard")}
                            type={"button"}
                            typeStyle={"fill"}
                            borderRadius={false}
                            iconPath={addIcon}
                            altIcon={"add"}
                            style={{borderRadius: "10px", maxWidth: "240px"}}
                            functionOnClick={() => {
                                setShowAddPaymentPopup(true)
                            }

                            }
                        />
                    </div>
                </section>
                {
                    showAddPaymentPopup && (
                        <StripeElements>
                            <AddPaymentMethodPopup
                                closePopupFn={hideAddPaymentMethodPopup}
                                getPaymentsMethodFn={getPaymentMethods}
                            />
                        </StripeElements>
                    )
                }
            </>

        )
    }

    return (
        <>
            <section className={styles.section}>
                <div className="container">
                    <div className={styles.wrapper}>
                        {paymentMethods.data.map(el => {
                            return (
                                <AccountCardItem key={el.id} item={el} getPaymentMethods={getPaymentMethods}/>
                            )
                        })}
                    </div>
                    <CustomButton
                        text={t("AddNewCard")}
                        type={"button"}
                        typeStyle={"fill"}
                        borderRadius={false}
                        style={{borderRadius: "5px", maxWidth: "240px"}}
                        functionOnClick={() => setShowAddPaymentPopup(true)}
                    />
                </div>
            </section>
            {
                showAddPaymentPopup && (
                    <StripeElements>
                        <AddPaymentMethodPopup
                            closePopupFn={hideAddPaymentMethodPopup}
                            getPaymentsMethodFn={getPaymentMethods}
                        />
                    </StripeElements>
                )
            }
        </>

    )
}

export default AccountCards;